.error {
  display: flex;
  flex-flow: column nowrap;
  gap: var(--mantine-spacing-md);
  place-self: center;
  width: 50rem;
  max-width: 60dvw;
  padding: var(--mantine-spacing-xl);
  font-size: var(--mantine-font-size-md);
  background: #eee;
  h1 {
    margin: 0;
    font-size: var(--mantine-font-size-xl);
  }
  .location {
    padding-top: var(--mantine-spacing-md);
    margin-top: var(--mantine-spacing-md);
    font-size: var(--mantine-font-size-xs);
    border-top: 1px solid #aaa;
  }
  pre {
    height: 10rem;
    max-height: 30dvh;
    padding: var(--mantine-spacing-md);
    overflow: auto;
    font-size: calc(var(--mantine-font-size-md) * 0.6);
    color: #555;
    background: #ddd;
  }
}
